__turbopack_context__.v({
  "helios-prose": "TysX3G_helios-prose",
  "helios-prose--align-center": "TysX3G_helios-prose--align-center",
  "helios-prose--size-article": "TysX3G_helios-prose--size-article",
  "helios-prose--size-compact": "TysX3G_helios-prose--size-compact",
  "helios-prose--size-default": "TysX3G_helios-prose--size-default",
});
